export default __webpack_public_path__ + "static/media/connectify.ce2c20c8.svg";